var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReopenIconGreyed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#ECECEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 42a1.333 1.333 0 0 1-1.334-1.333V19.333c0-.736.598-1.333 1.334-1.333h9.885l2.667 2.667h10.114c.737 0 1.334.597 1.334 1.333v4h-2.667v-2.667h-9.885l-2.667-2.666h-7.448v15.997l2-7.997H44L40.919 40.99A1.333 1.333 0 0 1 39.625 42H18zm22.584-10.667H23.415l-2 8h17.17l2-8z",
    fill: "#91919C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReopenIconGreyed);
export default __webpack_public_path__ + "static/media/reopen-icon-greyed.380994fee915200f8fa4e80544e6cb13.svg";
export { ForwardRef as ReactComponent };